export function normalizeArabic(text: string = ''): string {
  return text
    .normalize('NFC')
    .replace(/آ|أ|إ|ٱ/g, 'ا')
    .replace(/ي|ى/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/ة/g, 'ه')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ی')
    .replace(/ـ/g, '')
    .replace(/[\u064B-\u065F]/g, '')
    .replace(/[٠-٩]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1632 + 48))
    .replace(/[۰-۹]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1776 + 48));
}
